export default {
  required: 'This field is required',
  email: 'Please enter a valid email address',
  phone: 'Please enter a valid phone number',
  minLength: 'Minimum {min} characters required',
  maxLength: 'Maximum {max} characters allowed',
  number: 'Please enter a number',
  integer: 'Please enter an integer',
  positive: 'Please enter a positive number',
  url: 'Please enter a valid URL',
  passwordMismatch: 'Passwords do not match',
  passwordWeak: 'Password strength is insufficient',
};
